
import { PageRequest } from "@/store/shared/entity";
import {
  Component,
  Mixins,
  ActionButtonConfig,
  PageResultBaseMixins,
  PageResultModalMixins,
  appConst,
} from "@/lib";
class PageFreightForwarderTowingContainerStatisticsRequest extends PageRequest {
   shipmentDate=[new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0,10),new Date().toISOString().slice(0,10)];
   logisticsId: number;
}
@Component({
  name: "freightforwardertowingcontainerstatistics",
  components: {},
})
export default class FreightForwarderTowingContainerStatistics extends Mixins(
  PageResultBaseMixins,
  PageResultModalMixins
) {
  dataone:Array<any> = [];
  datatwo:Array<any> = [];
  config = {
    model: new PageFreightForwarderTowingContainerStatisticsRequest(),
    queryAction: "counterstatistics/freightforwardertowingcontainerstatistics/getAll",
    isAutoQuery: false,
    labelWidth: 120,
  };
  reset() {
    this.config.model = new PageFreightForwarderTowingContainerStatisticsRequest();
  }
  async created() {
    await this.$store.dispatch("system/logistics/getIsTraileLogisticsList");
  }
  get logisticsLists() {
    return this.$store.state.system.logistics.logisticsList;
  }
   get oneList(){
         return this.$store.state.counterstatistics.freightforwardertowingcontainerstatistics.one;
    }
    get twoList(){
         return this.$store.state.counterstatistics.freightforwardertowingcontainerstatistics.two;
         ;
    }
  get option() {
    //    [
    //         { value: 40, name: "rose 1" },
    //         { value: 33, name: "rose 2" },
    //         { value: 28, name: "rose 3" },
    //         { value: 22, name: "rose 4" },
    //         { value: 20, name: "rose 5" },
    //         { value: 15, name: "rose 6" },
    //         { value: 12, name: "rose 7" },
    //         { value: 10, name: "rose 8" },
    //     ]
      this.dataone = [];
      this.oneList.forEach(element => {
          if(element.boxType=="20GP"&&element.total20GP!=0){
              this.dataone.push({
              value:element.total20GP,
              name:element.boxType});
          }
          else if(element.boxType=="40GP"&&element.total40GP!=0){
               this.dataone.push({
              value:element.total40GP,
              name:element.boxType});
          }
          else if(element.boxType=="40HQ"&&element.total40HQ!=0){
               this.dataone.push({
              value:element.total40HQ,
              name:element.boxType});
          }
          else if(element.boxType=="45HQ"&&element.total45HQ!=0){
               this.dataone.push({
              value:element.total45HQ,
              name:element.boxType});
          }
      });
      return {
        tooltip: {
         trigger: 'item',
         formatter: '{b} : {c} ({d}%)'
         },
        series: [
            {
                type: "pie",
                radius: [50, 140],
                center: ["50%", "50%"],
                itemStyle: {
                    borderRadius: 8,
                },
                label: {
                    show: true,
                },
                emphasis: {
                    label: {
                        show: true,
                    },
                },
                data: this.dataone,
            },
        
        ],
    }
  }
 get optiontwo() {
   this.datatwo = [];
      this.twoList.forEach(element => {
          this.datatwo.push({
              value:element.totalLogistics,
              name:element.logisticsName});
      });
      return {
        tooltip: {
         trigger: 'item',
         formatter: '{b} : {c} ({d}%)'
         },
        series: [
            {
                type: "pie",
                radius: [50, 140],
                center: ['50%', '50%'],
                itemStyle: {
                    borderRadius: 8,
                },
                label: {
                    show: true,
                },
                 roseType: 'area',
                emphasis: {
                    label: {
                        show: true,
                    },
                },
                data: this.datatwo,
            },
        
        ],
    }
  }
  dateChange(value) {
    let start = this.$util.format.date(value[0]);
    let end = this.$util.format.date(value[1]);
    this.config.model.shipmentDate = [start, end];
  }
}
